<script>
  import holster from "@/img/holster.gif";
  import { isMobile } from "@/function/media.js";
</script>

<div class:mobile={$isMobile}>
  <div class="row">
    <div class="col-md-4 col-sm-6 content-card">
      <div class="notice-card-shadow">
        <div class="notice-card card-information">
          <div class="content">
            <h3>Please see the charger for more information.</h3>

            <p class="description">
              Please note that <b style="text-decoration:underline">
                you'll have 30 seconds to connect your vehicle</b
              > to the charger. If the vehicle is not connected within 30 seconds,
              the charging session will be cancelled until you try again.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="success">
      <img alt="Charge started" src={holster} />
      <div class="message"><b>Charging initiated!</b></div>
      <div class="sub-message">Check charger screen for more information.</div>
    </div>
  </div>
</div>

<style>
  div.mobile {
    margin: 0;
    padding: 0;
  }

  .mobile .row {
    padding: initial;
  }

  .mobile .content {
    padding: 5px !important;
  }

  .mobile .success .message {
    font-size: 2em;
  }

  .mobile .success .sub-message {
    font-size: 0.9em;
  }

  .mobile img {
    padding-left: 47px;
  }

  .success img {
    max-width: 100%;
  }
  .success .message {
    margin-top: 20px;
    font-size: 3em;
  }
  .success .sub-message {
    margin-top: 5px;
    font-size: 2em;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 98%;
  }

  .row {
    display: grid;
  }

  .row {
    padding: 16px;
  }

  .row {
    margin-top: 15px;
    text-align: center;
    margin: auto;
  }

  .notice-card-shadow {
    position: relative;
  }

  .content-card {
    margin-top: 30px;
    margin-left: 50px;
    margin: auto;
  }

  .notice-card {
    border-radius: 10px;
  }

  .notice-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(164, 164, 0, 0.5);
    background-color: #ffffff;
    color: #252422;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    background: #fceba6;
  }

  .notice-card.card-information .content {
    padding: 5px 55px;
    text-align: center;
  }

  .notice-card .content {
    padding: 20px 20px 10px 20px;
  }

  .notice-card-shadow:before {
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    bottom: -12%;
    content: "";
    display: block;
    left: -12%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
  }

  .notice-card .description {
    font-size: 16px;
    color: #66615b;
  }

  .notice-card .content h3 {
    font-size: 1.3em;
    font-weight: 900;
    line-height: 1.5em;
    width: auto;
    color: #008000;
  }
</style>
